import {
  CAMPAIGN_APPROVAL_STATUS,
  CAMPAIGN_APPROVAL_STEP_TYPE,
  CAMPAIGN_TRIGGER_TYPE,
} from '@baserow/modules/core/models/campaignApprovals'

const MOCK_APPROVALS = [
  {
    id: 'approval-gate-1001-email-draft',
    workspaceId: 1,
    gateId: 'gate-1001-email-draft',
    runId: 'run-1001',
    agentId: 'agent-enterprise-outbound',
    agentName: 'Enterprise outbound assistant',
    triggerType: CAMPAIGN_TRIGGER_TYPE.ROW_UPDATED,
    triggerEventSource: 'baserow.table.enterprise_accounts',
    triggerEventType: 'lead.ready_for_outreach',
    status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
    requestedAction: {
      type: 'APPROVE_PROCESS_AGENT_RUN',
      output: {
        llmDecision: {
          subject: 'Reduce manual revenue ops follow-up this quarter',
          body: 'Hi Maria,\n\nYour team is scaling pipeline work across several regions. Vokalis can help keep prospect research, approvals, and outreach handoffs visible before a campaign run goes live.\n\nWould it be useful to compare your current workflow with a lighter approval path this week?',
        },
        connectInteraction: {
          rowId: 5421,
          resourceId: 'table-enterprise-accounts',
          integrationId: 'baserow-connect-main',
        },
      },
    },
    runOutput: {
      campaignName: 'Enterprise pipeline Q3',
      summary:
        'The agent drafted a first-touch email after detecting a ready lead row.',
      audience: 'COO, VP Operations, Head of Revenue Operations',
      estimatedRecipients: 184,
    },
    createdAt: '2026-07-21T08:30:00.000Z',
    startedAt: '2026-07-21T08:25:00.000Z',
  },
  {
    id: 'approval-gate-1002-local-retail',
    workspaceId: 1,
    gateId: 'gate-1002-local-retail',
    runId: 'run-1002',
    agentId: 'agent-retail-expansion',
    agentName: 'Retail expansion assistant',
    triggerType: CAMPAIGN_TRIGGER_TYPE.ROW_CREATED,
    triggerEventSource: 'baserow.table.retail_locations',
    triggerEventType: 'location.qualified',
    status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
    requestedAction: {
      type: 'APPROVE_PROCESS_AGENT_RUN',
      output: {
        llmDecision: {
          subject: 'A practical way to coordinate local retail campaigns',
          body: 'Hi Ana,\n\nI noticed your team coordinates retail growth across multiple cities. Vokalis helps keep campaign context, leads, and approval gates in one workspace before outreach starts.\n\nOpen to a short walkthrough?',
        },
        connectInteraction: {
          rowId: 3138,
          resourceId: 'table-retail-locations',
          integrationId: 'baserow-connect-main',
        },
      },
    },
    runOutput: {
      campaignName: 'Retail expansion Spain',
      summary:
        'The agent generated outreach for a newly qualified retail location.',
      audience: 'Retail directors and store operations leads in Spain',
      estimatedRecipients: 96,
    },
    createdAt: '2026-07-20T13:15:00.000Z',
    startedAt: '2026-07-20T13:08:00.000Z',
  },
  {
    id: 'approval-gate-1003-partner-reactivation',
    workspaceId: 1,
    gateId: 'gate-1003-partner-reactivation',
    runId: 'run-1003',
    agentId: 'agent-partner-reactivation',
    agentName: 'Partner reactivation assistant',
    triggerType: CAMPAIGN_TRIGGER_TYPE.MANUAL_RUN,
    triggerEventSource: 'connect.campaigns.partner_reactivation',
    triggerEventType: 'run.started',
    status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
    requestedAction: {
      type: 'APPROVE_PROCESS_AGENT_RUN',
      output: {
        llmDecision: {
          subject: 'Reopening the partner enablement conversation',
          body: 'Hi Alex,\n\nWe have updated the enablement path for partners that paused rollout earlier this year. The new campaign assets focus on faster qualification and clearer approval checkpoints.\n\nShould we reconnect next week?',
        },
        connectInteraction: {
          rowId: 8804,
          resourceId: 'table-partner-accounts',
          integrationId: 'hubspot-connect-emea',
        },
      },
    },
    runOutput: {
      campaignName: 'Partner reactivation',
      summary:
        'The agent selected a dormant partner and prepared the reactivation email.',
      audience: 'Dormant implementation partners across EMEA',
      estimatedRecipients: 241,
    },
    createdAt: '2026-07-19T09:45:00.000Z',
    startedAt: '2026-07-19T09:39:00.000Z',
  },
]

const MOCK_TIMELINES = {
  'run-1001': {
    run: {
      id: 'run-1001',
      agentId: 'agent-enterprise-outbound',
      agentName: 'Enterprise outbound assistant',
      status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
      startedAt: '2026-07-21T08:25:00.000Z',
      output: MOCK_APPROVALS[0].runOutput,
    },
    steps: [
      {
        id: 'step-1001-llm-decision',
        type: CAMPAIGN_APPROVAL_STEP_TYPE.LLM_DECISION,
        status: CAMPAIGN_APPROVAL_STATUS.SUCCESS,
        title: 'Email draft generated',
        description:
          'The agent selected the outreach angle and drafted the email.',
        startedAt: '2026-07-21T08:25:00.000Z',
        completedAt: '2026-07-21T08:29:00.000Z',
      },
      {
        id: 'step-1001-human-gate',
        type: CAMPAIGN_APPROVAL_STEP_TYPE.HUMAN_GATE,
        status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
        title: 'Approval requested',
        description:
          'The draft is paused until a human approves or rejects it.',
        startedAt: '2026-07-21T08:30:00.000Z',
        completedAt: null,
        gateId: 'gate-1001-email-draft',
      },
      {
        id: 'step-1001-email-send',
        type: CAMPAIGN_APPROVAL_STEP_TYPE.EMAIL_SEND,
        status: CAMPAIGN_APPROVAL_STATUS.IN_PROGRESS,
        title: 'Email send queued',
        description: 'Sending starts only after the human gate succeeds.',
        startedAt: null,
        completedAt: null,
      },
    ],
    approvalGates: [
      {
        gateId: 'gate-1001-email-draft',
        status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
        requestedAt: '2026-07-21T08:30:00.000Z',
        decidedAt: null,
        decidedBy: null,
      },
    ],
  },
  'run-1002': {
    run: {
      id: 'run-1002',
      agentId: 'agent-retail-expansion',
      agentName: 'Retail expansion assistant',
      status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
      startedAt: '2026-07-20T13:08:00.000Z',
      output: MOCK_APPROVALS[1].runOutput,
    },
    steps: [
      {
        id: 'step-1002-action',
        type: CAMPAIGN_APPROVAL_STEP_TYPE.ACTION,
        status: CAMPAIGN_APPROVAL_STATUS.SUCCESS,
        title: 'Qualified row received',
        description: 'The trigger row passed the campaign qualification rules.',
        startedAt: '2026-07-20T13:08:00.000Z',
        completedAt: '2026-07-20T13:10:00.000Z',
      },
      {
        id: 'step-1002-llm-decision',
        type: CAMPAIGN_APPROVAL_STEP_TYPE.LLM_DECISION,
        status: CAMPAIGN_APPROVAL_STATUS.SUCCESS,
        title: 'Email draft generated',
        description: 'The agent drafted a localized retail operations email.',
        startedAt: '2026-07-20T13:10:00.000Z',
        completedAt: '2026-07-20T13:14:00.000Z',
      },
      {
        id: 'step-1002-human-gate',
        type: CAMPAIGN_APPROVAL_STEP_TYPE.HUMAN_GATE,
        status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
        title: 'Approval requested',
        description: 'The outbound action is paused for human review.',
        startedAt: '2026-07-20T13:15:00.000Z',
        completedAt: null,
        gateId: 'gate-1002-local-retail',
      },
    ],
    approvalGates: [
      {
        gateId: 'gate-1002-local-retail',
        status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
        requestedAt: '2026-07-20T13:15:00.000Z',
        decidedAt: null,
        decidedBy: null,
      },
    ],
  },
  'run-1003': {
    run: {
      id: 'run-1003',
      agentId: 'agent-partner-reactivation',
      agentName: 'Partner reactivation assistant',
      status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
      startedAt: '2026-07-19T09:39:00.000Z',
      output: MOCK_APPROVALS[2].runOutput,
    },
    steps: [
      {
        id: 'step-1003-action',
        type: CAMPAIGN_APPROVAL_STEP_TYPE.ACTION,
        status: CAMPAIGN_APPROVAL_STATUS.SUCCESS,
        title: 'Partner account selected',
        description: 'The run matched a dormant implementation partner.',
        startedAt: '2026-07-19T09:39:00.000Z',
        completedAt: '2026-07-19T09:41:00.000Z',
      },
      {
        id: 'step-1003-llm-decision',
        type: CAMPAIGN_APPROVAL_STEP_TYPE.LLM_DECISION,
        status: CAMPAIGN_APPROVAL_STATUS.SUCCESS,
        title: 'Email draft generated',
        description: 'The agent prepared a partner reactivation message.',
        startedAt: '2026-07-19T09:41:00.000Z',
        completedAt: '2026-07-19T09:44:00.000Z',
      },
      {
        id: 'step-1003-human-gate',
        type: CAMPAIGN_APPROVAL_STEP_TYPE.HUMAN_GATE,
        status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
        title: 'Approval requested',
        description: 'Final human approval is required before sending.',
        startedAt: '2026-07-19T09:45:00.000Z',
        completedAt: null,
        gateId: 'gate-1003-partner-reactivation',
      },
      {
        id: 'step-1003-email-send',
        type: CAMPAIGN_APPROVAL_STEP_TYPE.EMAIL_SEND,
        status: CAMPAIGN_APPROVAL_STATUS.FAILED,
        title: 'Previous send attempt blocked',
        description:
          'A prior send attempt failed because approval was missing.',
        startedAt: '2026-07-19T09:46:00.000Z',
        completedAt: '2026-07-19T09:46:00.000Z',
      },
    ],
    approvalGates: [
      {
        gateId: 'gate-1003-partner-reactivation',
        status: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
        requestedAt: '2026-07-19T09:45:00.000Z',
        decidedAt: null,
        decidedBy: null,
      },
    ],
  },
}

const BACKEND_ENDPOINTS = Object.freeze({
  pending: '/vokalis/process-agent-approvals/pending/',
  runs: '/vokalis/process-agent-runs/',
  timeline(runId) {
    return `/vokalis/process-agent-runs/${encodeURIComponent(runId)}/timeline/`
  },
  approve(runId) {
    return `/vokalis/process-agent-runs/${encodeURIComponent(runId)}/approve/`
  },
  reject(runId) {
    return `/vokalis/process-agent-runs/${encodeURIComponent(runId)}/reject/`
  },
})

function clone(value) {
  return JSON.parse(JSON.stringify(value))
}

function waitForMock(value) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(clone(value)), 180)
  })
}

function waitForMockResult(value) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(value), 180)
  })
}

function updateTimelineGate(timeline, gateId, status, actor) {
  if (!timeline) {
    return
  }
  const decidedAt = new Date().toISOString()
  timeline.run.status = status
  const gate = timeline.approvalGates.find((item) => item.gateId === gateId)
  if (gate) {
    gate.status = status
    gate.decidedAt = decidedAt
    gate.decidedBy = actor
  }
  const step = timeline.steps.find((item) => item.gateId === gateId)
  if (step) {
    step.status = status
    step.completedAt = decidedAt
  }
}

function createMockApprovalsAdapter() {
  const approvals = clone(MOCK_APPROVALS)
  const timelines = clone(MOCK_TIMELINES)

  return {
    listAll(workspaceId, options = {}) {
      return waitForMockResult(
        mockApprovalPage(approvals, workspaceId, options)
      )
    },
    getTimeline(workspaceId, runId) {
      const workspaceScope = Number(workspaceId)
      const hasWorkspaceRun =
        Number.isFinite(workspaceScope) &&
        approvals.some((approval) => approval.runId === runId)
      return waitForMock(hasWorkspaceRun ? timelines[runId] : null)
    },
    approve(workspaceId, approval) {
      return decideMockApproval(
        workspaceId,
        approvals,
        timelines,
        approval,
        CAMPAIGN_APPROVAL_STATUS.SUCCESS
      )
    },
    reject(workspaceId, approval) {
      return decideMockApproval(
        workspaceId,
        approvals,
        timelines,
        approval,
        CAMPAIGN_APPROVAL_STATUS.REJECTED
      )
    },
  }
}

function mockApprovalPage(approvals, workspaceId, options = {}) {
  const agentId = options.agentId
  const filteredApprovals = agentId
    ? approvals.filter((approval) => approval.agentId === agentId)
    : approvals
  const start = Number(options.cursor || 0) || 0
  const limit = Number(options.limit || filteredApprovals.length)
  const end = start + limit
  const page = filteredApprovals
    .slice(start, end)
    .map((approval) => ({ ...approval, workspaceId }))
  const nextCursor = end < filteredApprovals.length ? String(end) : null
  return withPaginationMetadata(page, {
    nextCursor,
    cursor: options.cursor || null,
    limit: options.limit || null,
    hasMore: Boolean(nextCursor),
  })
}

function decideMockApproval(
  workspaceId,
  approvals,
  timelines,
  approval,
  status
) {
  const workspaceScope = Number(workspaceId)
  const approvalId = approvalIdFrom(approval)
  const storedApproval = Number.isFinite(workspaceScope)
    ? approvals.find((item) => item.id === approvalId)
    : null
  if (!storedApproval) {
    return Promise.reject(new Error('Approval was not found.'))
  }
  storedApproval.status = status
  updateTimelineGate(
    timelines[storedApproval.runId],
    storedApproval.gateId,
    status,
    'Current user'
  )
  return waitForMock(storedApproval)
}

function createHttpApprovalsAdapter(client) {
  return {
    async listAll(workspaceId, options = {}) {
      const [{ data: pendingData }, historicalResponse] = await Promise.all([
        client.get(BACKEND_ENDPOINTS.pending, {
          params: pendingQueryParams(workspaceId, options),
        }),
        options.cursor
          ? Promise.resolve({ data: null })
          : client.get(BACKEND_ENDPOINTS.runs, {
              params: historicalRunsQueryParams(workspaceId, options),
            }),
      ])
      const pendingApprovals = normalizeApprovalList(pendingData, workspaceId)
      const historicalApprovals = normalizeHistoricalRunList(
        historicalResponse.data,
        workspaceId
      )
      return withPaginationMetadata(
        [...pendingApprovals, ...historicalApprovals],
        pendingApprovals.pagination
      )
    },
    async getTimeline(workspaceId, runId) {
      const { data } = await client.get(BACKEND_ENDPOINTS.timeline(runId), {
        params: { workspace_id: workspaceId },
      })
      return normalizeTimeline(data)
    },
    approve(workspaceId, approval) {
      return this.decide(workspaceId, approval, 'approve')
    },
    reject(workspaceId, approval) {
      return this.decide(workspaceId, approval, 'reject')
    },
    async decide(workspaceId, approval, decision) {
      const runId = runIdFrom(approval)
      if (!runId) {
        throw contractUnavailableError()
      }
      const endpoint =
        decision === 'approve'
          ? BACKEND_ENDPOINTS.approve(runId)
          : BACKEND_ENDPOINTS.reject(runId)
      const body = {
        workspace_id: workspaceId,
        approval_id: approvalIdFrom(approval),
        gate_id: gateIdFrom(approval),
      }
      const notes = notesFrom(approval)
      if (notes) {
        body.notes = notes
      }
      const { data } = await client.post(endpoint, body)
      return normalizeDecisionApproval(data, workspaceId, approval, decision)
    },
  }
}

function contractUnavailableAdapter() {
  return {
    listAll() {
      throw contractUnavailableError()
    },
    getTimeline() {
      throw contractUnavailableError()
    },
    approve() {
      throw contractUnavailableError()
    },
    reject() {
      throw contractUnavailableError()
    },
  }
}

function normalizeBooleanFlag(value) {
  if (value === true) {
    return true
  }
  if (value === false || value === undefined || value === null) {
    return false
  }
  return ['1', 'true', 'yes', 'on', 'mock', 'demo'].includes(
    String(value).trim().toLowerCase()
  )
}

function queryFlagFrom(query = {}) {
  return (
    query.campaignApprovalsMock ??
    query.mockCampaignApprovals ??
    query.vokalisCampaignApprovalsMock ??
    query.vokalis_mocks
  )
}

function localStorageFlagFrom(localStorage) {
  if (!localStorage || typeof localStorage.getItem !== 'function') {
    return undefined
  }
  try {
    return (
      localStorage.getItem('vokalis.campaignApprovals.mockMode') ??
      localStorage.getItem('campaignApprovalsMock')
    )
  } catch (error) {
    return undefined
  }
}

function envFlagFrom(env = {}) {
  return (
    env.VOKALIS_CAMPAIGN_APPROVALS_MOCKS ??
    env.NUXT_ENV_VOKALIS_CAMPAIGN_APPROVALS_MOCKS ??
    env.CAMPAIGN_APPROVALS_MOCKS
  )
}

export function isApprovalBusinessConflict(error) {
  const status = error?.response?.status || error?.status || error?.statusCode
  return Number(status) === 409
}

export function shouldUseMockCampaignApprovals({
  query = {},
  localStorage = null,
  env = {},
} = {}) {
  return (
    normalizeBooleanFlag(queryFlagFrom(query)) ||
    normalizeBooleanFlag(localStorageFlagFrom(localStorage)) ||
    normalizeBooleanFlag(envFlagFrom(env))
  )
}

function pendingQueryParams(workspaceId, options = {}) {
  const params = { workspace_id: workspaceId }
  const contractQueryFields = ['limit', 'cursor', 'agentId']
  contractQueryFields.forEach((field) => {
    if (options[field] !== undefined && options[field] !== null) {
      params[field] = options[field]
    }
  })
  return params
}

function historicalRunsQueryParams(workspaceId, options = {}) {
  const params = {
    workspace_id: workspaceId,
    statuses: [
      CAMPAIGN_APPROVAL_STATUS.SUCCESS,
      CAMPAIGN_APPROVAL_STATUS.REJECTED,
    ].join(','),
    hasApprovalGate: true,
    limit: options.historicalLimit || options.limit || 25,
  }
  if (options.agentId !== undefined && options.agentId !== null) {
    params.agentId = options.agentId
  }
  return params
}

function normalizeApprovalList(payload, workspaceId) {
  const source = approvalCollectionSourceFrom(payload)
  const approvals = (approvalListFrom(source) || []).map((approval) =>
    normalizeApproval(approval, workspaceId)
  )
  return withPaginationMetadata(approvals, paginationMetadataFrom(source))
}

function normalizeHistoricalRunList(payload, workspaceId) {
  const source = approvalCollectionSourceFrom(payload)
  const runs = approvalListFrom(source) || []
  return runs
    .filter((run) => isHumanGatedHistoricalRun(run))
    .map((run) => normalizeRunAsApproval(run, workspaceId))
}

function isHumanGatedHistoricalRun(payload) {
  const source = payload?.run || payload || {}
  if (source.requiresApproval === true) {
    return true
  }
  const status = normalizeStatusValue(source.status)
  if (
    status === CAMPAIGN_APPROVAL_STATUS.REJECTED ||
    status === CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL
  ) {
    return true
  }
  if (source.latestApprovalGate || source.latest_approval_gate) {
    return true
  }
  if (firstApprovalGate(source)) {
    return true
  }
  const output = source.output || source.runOutput || source.run_output || {}
  if (
    output.approvalGate ||
    output.approval_gate ||
    output.approvalGateId ||
    output.approval_gate_id
  ) {
    return true
  }
  const approval = output.approval || source.approval
  if (approval && typeof approval === 'object') {
    const hasApprovalSignal = Object.values(approval).some(
      (value) => value !== undefined && value !== null && value !== ''
    )
    if (hasApprovalSignal) {
      return true
    }
  }
  const requestedAction =
    source.requestedAction ||
    source.requested_action ||
    approval?.requestedAction ||
    approval?.requested_action
  const requestedType = String(requestedAction?.type || '').toUpperCase()
  return (
    requestedType.includes('APPROVE') || requestedType.includes('EMAIL_APPROVAL')
  )
}

function normalizeRunAsApproval(payload, workspaceId) {
  const source = payload?.run || payload
  const output = source.output || source.runOutput || source.run_output || {}
  const approval = output.approval || source.approval || {}
  const approvalGate =
    firstApprovalGate(source) ||
    source.latestApprovalGate ||
    source.latest_approval_gate ||
    output.approvalGate ||
    output.approval_gate ||
    null
  const requestedAction =
    approval.requestedAction ||
    approval.requested_action ||
    source.requestedAction ||
    source.requested_action ||
    output.requestedAction ||
    output.requested_action ||
    {}
  return normalizeApproval(
    {
      ...approval,
      ...source,
      id:
        approval.id ||
        approval.approvalId ||
        approval.approval_id ||
        approvalGate?.gateId ||
        approvalGate?.gate_id ||
        approvalGate?.id ||
        source.id ||
        source.runId ||
        source.run_id,
      gateId:
        approval.gateId ||
        approval.gate_id ||
        approvalGate?.gateId ||
        approvalGate?.gate_id ||
        approvalGate?.id,
      runId: source.runId || source.run_id || source.id,
      agentId: source.agentId || source.agent_id,
      agentName: source.agentName || source.agent_name,
      requestedAction,
      runOutput: {
        ...output,
        approval,
        summary: output.summary || source.summary || '',
      },
      createdAt:
        approval.requestedAt ||
        approval.requested_at ||
        approvalGate?.requestedAt ||
        approvalGate?.requested_at ||
        approvalGate?.createdAt ||
        approvalGate?.created_at ||
        source.createdAt ||
        source.created_at ||
        source.startedAt ||
        source.started_at,
      startedAt: source.startedAt || source.started_at,
      status: source.status || approval.status || approvalGate?.status,
    },
    workspaceId
  )
}

function firstApprovalGate(source) {
  const gates = source?.approvalGates || source?.approval_gates
  return Array.isArray(gates) && gates.length > 0 ? gates[0] : null
}

function approvalCollectionSourceFrom(payload) {
  if (!payload || Array.isArray(payload) || typeof payload !== 'object') {
    return payload
  }
  if (Array.isArray(payload.data)) {
    return payload
  }
  if (
    payload.items ||
    payload.approvals ||
    payload.pending ||
    payload.results
  ) {
    return payload
  }
  return payload.data || payload
}

function withPaginationMetadata(approvals, pagination) {
  if (pagination) {
    Object.defineProperty(approvals, 'pagination', {
      value: pagination,
      enumerable: false,
      configurable: true,
    })
  }
  return approvals
}

function paginationMetadataFrom(payload) {
  if (!payload || Array.isArray(payload) || typeof payload !== 'object') {
    return null
  }
  const nextCursor = payload.nextCursor || payload.next_cursor || null
  const cursor = payload.cursor || null
  const limit = payload.limit || null
  const hasMore = payload.hasMore ?? payload.has_more
  if (!nextCursor && !cursor && !limit && hasMore === undefined) {
    return null
  }
  return {
    nextCursor,
    cursor,
    limit,
    hasMore: hasMore === undefined ? Boolean(nextCursor) : Boolean(hasMore),
  }
}

function approvalListFrom(payload) {
  if (Array.isArray(payload)) {
    return payload
  }
  if (!payload || typeof payload !== 'object') {
    return null
  }
  return (
    approvalListFrom(payload.approvals) ||
    approvalListFrom(payload.pending) ||
    approvalListFrom(payload.results) ||
    approvalListFrom(payload.items) ||
    approvalListFrom(payload.data)
  )
}

const APPROVAL_STATUS_ALIASES = Object.freeze({
  waitingapproval: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
  waitingapprovalpending: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
  pending: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
  pendingapproval: CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL,
  approved: CAMPAIGN_APPROVAL_STATUS.SUCCESS,
  approve: CAMPAIGN_APPROVAL_STATUS.SUCCESS,
  success: CAMPAIGN_APPROVAL_STATUS.SUCCESS,
  succeeded: CAMPAIGN_APPROVAL_STATUS.SUCCESS,
  completed: CAMPAIGN_APPROVAL_STATUS.SUCCESS,
  done: CAMPAIGN_APPROVAL_STATUS.SUCCESS,
  rejected: CAMPAIGN_APPROVAL_STATUS.REJECTED,
  reject: CAMPAIGN_APPROVAL_STATUS.REJECTED,
  failed: CAMPAIGN_APPROVAL_STATUS.FAILED,
  failure: CAMPAIGN_APPROVAL_STATUS.FAILED,
  error: CAMPAIGN_APPROVAL_STATUS.FAILED,
  inprogress: CAMPAIGN_APPROVAL_STATUS.IN_PROGRESS,
  running: CAMPAIGN_APPROVAL_STATUS.IN_PROGRESS,
  processing: CAMPAIGN_APPROVAL_STATUS.IN_PROGRESS,
})

function normalizeStatusValue(status) {
  if (status === null || status === undefined) {
    return status
  }
  const rawStatus = String(status).trim()
  const canonicalStatus = rawStatus.toUpperCase()
  if (Object.values(CAMPAIGN_APPROVAL_STATUS).includes(canonicalStatus)) {
    return canonicalStatus
  }
  const aliasKey = rawStatus.toLowerCase().replace(/[^a-z0-9]/g, '')
  return APPROVAL_STATUS_ALIASES[aliasKey] || rawStatus
}

function normalizeTimeline(payload) {
  const timeline = payload?.timeline || payload?.data || payload
  if (!timeline) {
    return null
  }
  const normalized = clone(timeline)
  const approvalGates = normalized.approvalGates || normalized.approval_gates
  const gatesByStepId = Array.isArray(approvalGates)
    ? approvalGates.reduce((accumulator, gate) => {
        if (gate.stepId || gate.step_id) {
          accumulator[gate.stepId || gate.step_id] = gate
        }
        return accumulator
      }, {})
    : {}

  if (normalized.run) {
    normalized.run.status = normalizeStatusValue(normalized.run.status)
    normalized.run.output = {
      ...(normalized.run.output || {}),
      campaignName:
        normalized.run.output?.campaignName ||
        normalized.run.output?.campaign_name ||
        normalized.run.agentName ||
        normalized.run.agent_name ||
        '',
      summary: normalized.run.output?.summary || normalized.run.summary || '',
    }
  }
  if (Array.isArray(normalized.steps)) {
    normalized.steps = normalized.steps.map((step) => {
      const gate = gatesByStepId[step.id] || {}
      return {
        ...step,
        title: step.title || step.name || step.type || '',
        description: step.description || step.summary || step.error || '',
        gateId: step.gateId || step.gate_id || gate.gateId || gate.id,
        status: normalizeStatusValue(step.status),
      }
    })
  }
  if (Array.isArray(approvalGates)) {
    normalized.approvalGates = approvalGates.map((gate) => ({
      ...gate,
      gateId: gate.gateId || gate.gate_id || gate.id,
      status: normalizeStatusValue(gate.status),
    }))
    delete normalized.approval_gates
  }
  return normalized
}

function normalizeDecisionApproval(payload, workspaceId, approval, decision) {
  const source =
    payload && (payload.approval || payload.data || payload.result || payload)
  const updatedApproval = normalizeApproval(source, workspaceId, approval)
  if (
    !hasApprovalStatus(source) ||
    updatedApproval.status === approval.status
  ) {
    updatedApproval.status =
      decision === 'approve'
        ? CAMPAIGN_APPROVAL_STATUS.SUCCESS
        : CAMPAIGN_APPROVAL_STATUS.REJECTED
  }
  return updatedApproval
}

function hasApprovalStatus(source) {
  return Boolean(
    source &&
      (source.status !== undefined ||
        source.approvalStatus !== undefined ||
        source.approval_status !== undefined)
  )
}

function emailDraftFrom(source, fallback) {
  const email = source.requestedAction?.email || source.requested_action?.email
  const fallbackDecision = fallback.requestedAction?.output?.llmDecision
  const runDecision =
    source.runOutput?.llmDecision ||
    source.run_output?.llmDecision ||
    source.requestedAction?.output?.llmDecision
  return {
    subject:
      email?.subject ||
      source.runOutput?.emailDraft?.subject ||
      source.run_output?.emailDraft?.subject ||
      runDecision?.subject ||
      fallbackDecision?.subject ||
      '',
    body:
      email?.body ||
      source.runOutput?.emailDraft?.body ||
      source.run_output?.emailDraft?.body ||
      runDecision?.body ||
      fallbackDecision?.body ||
      '',
  }
}

function normalizeRequestedAction(source, fallback) {
  const requestedAction =
    source.requestedAction ||
    source.requested_action ||
    fallback.requestedAction ||
    {}
  if (requestedAction.output?.llmDecision) {
    return requestedAction
  }
  return {
    ...requestedAction,
    output: {
      ...(requestedAction.output || {}),
      llmDecision: emailDraftFrom(source, fallback),
      connectInteraction:
        requestedAction.output?.connectInteraction ||
        fallback.requestedAction?.output?.connectInteraction ||
        null,
    },
  }
}

function normalizeRunOutput(source, fallback) {
  const runOutput =
    source.runOutput || source.run_output || fallback.runOutput || {}
  const emailDraft = runOutput.emailDraft || {}
  return {
    ...runOutput,
    campaignName:
      runOutput.campaignName ||
      runOutput.campaign_name ||
      source.requestedAction?.title ||
      source.requested_action?.title ||
      source.agentName ||
      source.agent_name ||
      '',
    summary:
      runOutput.summary ||
      source.requestedAction?.summary ||
      source.requested_action?.summary ||
      '',
    audience: runOutput.audience || '',
    estimatedRecipients: Number(runOutput.estimatedRecipients || 0),
    emailDraft,
  }
}

function normalizeApproval(payload, workspaceId, fallbackApproval = null) {
  const source = payload || fallbackApproval || {}
  const fallback = fallbackApproval || {}
  const runOutput = normalizeRunOutput(source, fallback)
  const requestedAction = normalizeRequestedAction(
    { ...source, runOutput },
    fallback
  )
  return {
    ...clone(fallback),
    ...clone(source),
    id:
      source.id ||
      source.approvalId ||
      source.approval_id ||
      source.gateId ||
      source.gate_id ||
      fallback.id,
    workspaceId,
    gateId: source.gateId || source.gate_id || fallback.gateId,
    runId: source.runId || source.run_id || fallback.runId,
    agentId: source.agentId || source.agent_id || fallback.agentId,
    agentName: source.agentName || source.agent_name || fallback.agentName,
    triggerType:
      source.triggerType || source.trigger_type || fallback.triggerType,
    triggerEventSource:
      source.triggerEventSource ||
      source.trigger_event_source ||
      fallback.triggerEventSource,
    triggerEventType:
      source.triggerEventType ||
      source.trigger_event_type ||
      fallback.triggerEventType,
    requestedAction,
    runOutput,
    createdAt: source.createdAt || source.created_at || fallback.createdAt,
    startedAt: source.startedAt || source.started_at || fallback.startedAt,
    status: normalizeStatusValue(
      source.status ||
        source.approvalStatus ||
        source.approval_status ||
        fallback.status ||
        CAMPAIGN_APPROVAL_STATUS.WAITING_APPROVAL
    ),
  }
}

function contractUnavailableError() {
  const error = new Error('Backend contract is unavailable.')
  error.code = 'CONTRACT_UNAVAILABLE'
  return error
}

function approvalIdFrom(approval) {
  return typeof approval === 'string' ? approval : approval?.id
}

function runIdFrom(approval) {
  return typeof approval === 'string' ? null : approval?.runId
}

function gateIdFrom(approval) {
  return typeof approval === 'string' ? approval : approval?.gateId
}

function notesFrom(approval) {
  if (!approval || typeof approval === 'string') {
    return null
  }
  return (
    approval.notes || approval.decisionNotes || approval.decision_notes || null
  )
}

export default (client = null, options = {}) => {
  if (options.useMocks === true) {
    return createMockApprovalsAdapter()
  }
  if (!client) {
    return contractUnavailableAdapter()
  }
  return createHttpApprovalsAdapter(client)
}
